import React, { useEffect, useState } from 'react';
import './landing.css';
import { useTranslation } from '../../hooks/translation';

interface LandingProps {
  lang: string;
}

export const Landing: React.FC<LandingProps> = ({ lang }) => {
  const { t } = useTranslation(lang);
  const [index, setIndex] = useState(0);
  const [phase, setPhase] = useState<'enter' | 'exit'>('enter');

  useEffect(() => {
    const interval = setInterval(() => {
      setPhase('exit');
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % 4); // 4 frases
        setPhase('enter');
      }, 1200);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="landing" className="hero">
      
      <div className="hero-content">
        <div className="mask-image-bg"></div>
        <div className={`rotating-tagline ${phase}`}>
          <h2 className="tagline-title">{t(`landing.taglines.${index}.title`)}</h2>
          <p className="tagline-text">{t(`landing.taglines.${index}.text`)}</p>
        </div>
      </div>
    </section>
  );
};
